import React from 'react';
import T from './modules/translation';

function FontSize(props) {
  const options = [];
  for (let i = 5; i <= 15; i++) {
    options.push(<option key={i} value={i}>{i}</option>);
  }
  return (
    <div className="row mt-3 mb-3">
      <label htmlFor="fontSize" className="col-auto col-form-label">{T.get("fontSize")}</label>
      <div className="col-auto">
        <select id="fontSize"
          className="form-select"
          value={props.fontSize}
          onChange={props.onChange}>
          {options}
        </select>
      </div>
    </div>
  );
}

export default FontSize;